import { computed } from 'vue';
import XEUtils from 'xe-utils';
export function useWidgetName(props) {
    const computeKebabCaseName = computed(() => {
        const { renderOpts } = props;
        return renderOpts ? XEUtils.kebabCase(renderOpts.name) : '';
    });
    return {
        computeKebabCaseName
    };
}
